import React from 'react'
import PropTypes from 'prop-types'

const ChevronLeft = ({ color, width, height, double, ...props }) => {
  if (double) {
    return (
      <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path
          d='M11.8659 17.0041C11.7312 17.0036 11.5979 16.9759 11.4742 16.9226C11.3505 16.8693 11.2388 16.7916 11.1459 16.6941L7.28586 12.6941C7.10263 12.5072 7 12.2558 7 11.9941C7 11.7323 7.10263 11.481 7.28586 11.2941L11.2859 7.29409C11.3791 7.20085 11.4898 7.12689 11.6116 7.07643C11.7334 7.02597 11.864 7 11.9959 7C12.1277 7 12.2583 7.02597 12.3801 7.07643C12.5019 7.12689 12.6126 7.20085 12.7059 7.29409C12.7991 7.38733 12.8731 7.49802 12.9235 7.61984C12.974 7.74166 12.9999 7.87223 12.9999 8.00409C12.9999 8.13595 12.974 8.26652 12.9235 8.38834C12.8731 8.51016 12.7991 8.62085 12.7059 8.71409L9.40586 12.0041L12.5859 15.3041C12.7721 15.4915 12.8766 15.7449 12.8766 16.0091C12.8766 16.2733 12.7721 16.5267 12.5859 16.7141C12.4912 16.808 12.3788 16.882 12.2551 16.9318C12.1315 16.9816 11.9991 17.0062 11.8659 17.0041Z'
          fill={color}
        />
        <path
          d='M16.8659 17.0041C16.7312 17.0036 16.5979 16.9759 16.4742 16.9226C16.3505 16.8693 16.2388 16.7916 16.1459 16.6941L12.2859 12.6941C12.1026 12.5072 12 12.2558 12 11.9941C12 11.7323 12.1026 11.481 12.2859 11.2941L16.2859 7.29409C16.3791 7.20085 16.4898 7.12689 16.6116 7.07643C16.7334 7.02597 16.864 7 16.9959 7C17.1277 7 17.2583 7.02597 17.3801 7.07643C17.5019 7.12689 17.6126 7.20085 17.7059 7.29409C17.7991 7.38733 17.8731 7.49802 17.9235 7.61984C17.974 7.74166 17.9999 7.87223 17.9999 8.00409C17.9999 8.13595 17.974 8.26652 17.9235 8.38834C17.8731 8.51016 17.7991 8.62085 17.7059 8.71409L14.4059 12.0041L17.5859 15.3041C17.7721 15.4915 17.8766 15.7449 17.8766 16.0091C17.8766 16.2733 17.7721 16.5267 17.5859 16.7141C17.4912 16.808 17.3788 16.882 17.2551 16.9318C17.1315 16.9816 16.9991 17.0062 16.8659 17.0041Z'
          fill={color}
        />
      </svg>
    )
  }

  return (
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M13.36 17C13.2253 16.9995 13.0921 16.9718 12.9684 16.9185C12.8446 16.8652 12.7329 16.7875 12.64 16.69L8.78 12.69C8.59677 12.5031 8.49414 12.2518 8.49414 11.99C8.49414 11.7282 8.59677 11.4769 8.78 11.29L12.78 7.29C12.8732 7.19676 12.9839 7.1228 13.1057 7.07234C13.2276 7.02188 13.3581 6.99591 13.49 6.99591C13.6219 6.99591 13.7524 7.02188 13.8742 7.07234C13.9961 7.1228 14.1068 7.19676 14.2 7.29C14.2932 7.38324 14.3672 7.49393 14.4177 7.61575C14.4681 7.73758 14.4941 7.86814 14.4941 8C14.4941 8.13186 14.4681 8.26243 14.4177 8.38425C14.3672 8.50607 14.2932 8.61676 14.2 8.71L10.9 12L14.08 15.3C14.2662 15.4874 14.3708 15.7408 14.3708 16.005C14.3708 16.2692 14.2662 16.5226 14.08 16.71C13.9854 16.8039 13.8729 16.8779 13.7493 16.9277C13.6256 16.9775 13.4933 17.0021 13.36 17Z'
        fill={color}
      />
    </svg>
  )
}

ChevronLeft.defaultProps = {
  color: 'currentColor',
  width: '24',
  height: '24',
  double: false,
}

ChevronLeft.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  double: PropTypes.bool,
}

export default ChevronLeft
